export const DEFAULT_PAGE = 1;

export const PAGE_SIZE_100 = 100;

export const PAGE_SIZE_200 = 200;

export const PAGE_SIZE_500 = 500;

export const PAGE_SIZE_1000 = 1000;

export const PAGE_SIZE_5000 = 5000;
